import {
  ICountry,
  ICountryData
} from './index'

export interface ICityData {
  readonly id?: number
  name: string
  country?: ICountryData
}

export interface ICity extends ICityData {
  country?: ICountry

  path: string
  update(data?: ICityData): void
  validate(): boolean
}

export const CITY_NAME_MAX_LENGTH = 50
